import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { ImportDetailItemProps, ImportItemStatus } from "types/Import";

type ZimsImportData = {
  death: boolean;
  isGroup?: boolean;
  gender?: string;
  contraception?: string;
  birthDate?: string;
  houseName?: string;
  localId: string;
  zimsId: string;
  transponderId?: string;
  createdAnimalId?: string;
  band?: string;
};

function ImportZimsDetail({ item }: ImportDetailItemProps<ZimsImportData>) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col flex-1 justify-between pl-4 pr-6 mb-2 mt-2">
      <div className="flex-1 flex row items-center">
        <div className="flex items-center text-sm gap-4">
          {/* <TbFence className="w-5 h-5 mr-2" /> */}
          <h4 className="text-xl font-bold text-primary leading-4">
            {item.isGroup && <span>{t("common.individualsGroup")} : </span>}
            {item.houseName && <span>{item.houseName} | </span>}
            {item.zimsId ? `${item.zimsId} | ` : `${t("import.noZimsId")} | `}
            {item.localId ? item.localId : t("import.noLocalId")}
          </h4>
          <div className="px-2 rounded-md bg-green-100 text-green-800 border border-green-500 flex flex-col justify-center items-center text-sm w-fit">
            {t(item.gender ? `animals.${item.gender}` : "animals.undetermined")}
          </div>
          {item.death && (
            <div className="px-2 rounded-md bg-gray-100 text-gray-800 border border-gray-500 flex flex-col justify-center items-center text-sm w-fit">
              {t("animals.dead")}
            </div>
          )}
          {item.id && (
            <div className="px-2 rounded-md bg-orange-100 text-orange-800 border border-orange-500 flex flex-col justify-center items-center text-sm w-fit">
              {t("common.update")}
            </div>
          )}
          {item.birthDate && (
            <span>
              <strong>{t("import.birthDate")} :</strong>{" "}
              {dayjs(item.birthDate).format("DD/MM/YYYY")}
            </span>
          )}
        </div>
      </div>
      <div className="flex flex-row gap-4 mt-1">
        {item.status === ImportItemStatus.ERROR && item.errorDetails && (
          <span>
            <strong>{t("import.errorDetail")}</strong>
            {t(`import.errors.${item.errorDetails?.key}`)}
          </span>
        )}
        {item.contraception && (
          <span>
            <strong>{t("animals.contraception")} :</strong> {item.contraception}
          </span>
        )}
        {item.transponderId && (
          <span>
            <strong>{t("animals.transponderId")} :</strong>
            {` ${[item.transponderId]
              .filter((value) => value !== null && value !== undefined)
              .join(" / ")}`}
          </span>
        )}
        {item.band && (
          <span>
            <strong>{t("animals.band")} :</strong>
            {` ${[item.band]
              .filter((value) => value !== null && value !== undefined)
              .join(" / ")}`}
          </span>
        )}
      </div>
    </div>
  );
}

export default ImportZimsDetail;
